module.exports = __webpack_public_path__ + "assets/src/style/img/footer-nhl-stenden.png?ddac698814921b79e8c7c51424028314";